<template>
  <div class="picmanagetable">
    <el-table :data="tableData"
              style="width: 100%;padding:10px 10px 0 10px;"
              row-key="id"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
              border>
      <el-table-column prop="createAtMY"
                       label="创建日期"
                       width="220">
        <!-- <template slot-scope="scope">
          <span>{{formatConversion(scope.row.createAt)}}</span>
        </template> -->
      </el-table-column>
      <el-table-column prop="name"
                       label="图库名称">
      </el-table-column>
      <el-table-column prop="atlasCount"
                       v-if="false"
                       label="图集数">
      </el-table-column>
      <el-table-column prop="pictureCount"
                       v-if="false"
                       label="图片数">
      </el-table-column>

      <el-table-column prop="status"
                      width="80"
                       label="状态">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 1">
            <el-tag type="success">{{'开启'}}</el-tag>
          </div>

          <div v-if="scope.row.status === 0">
            <el-tag type="danger">{{'停用'}}</el-tag>
          </div>

          <div v-if="scope.row.status !== 0 && scope.row.status !== 1">
            <el-tag type="info">{{'无'}}</el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作"
                       width="320">
        <template slot-scope="scope">
          <el-button @click="changeClick(scope)"
                     style="color:#185ED3;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-edit-outline"></i>修改</el-button>
          <span style="margin:0 11px;"> | </span>
          <el-button @click="closeClick(scope)"
                     v-if="scope.row.status === 1"
                     style="color:#F96900;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-circle-close"></i>关闭</el-button>
          <el-button @click="closeClick(scope)"
                     v-if="scope.row.status !== 1"
                     style="color:#13aa65;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-document-checked"></i>开启</el-button>
          <!-- <span style="margin:0 11px;"> | </span>
          <el-button @click="removeClick(scope)" style="color:#FF4545;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-delete"></i>删除</el-button> -->
        </template>
      </el-table-column>

    </el-table>

    <mydialog @dialogSubmit="dialogSubmit"
              :title="title"
              :myform="myform"
              :label="label"
              :dialogFormVisible="dialogFormVisible"></mydialog>
  </div>
</template>

<script>
import { dialog } from '@/components/index'
import { mapActions } from 'vuex'
import { getLib } from "@/api/lib";
// import { getDate,formatConversion } from "@/plugins/getdate";
export default {
  name: 'picmanagetable',
  props: {
    tableData: Array,
  },
  components: {
    'mydialog': dialog
  },

  watch: {
    '$store.state.user.dialogFormVisible' (data) {
      this.dialogFormVisible = data
    },
    'myform' (data) {
      this.myform = data
      console.log(this.myform)
    },
  },

  data () {
    return {
      label: ['图库名称', '排序',"状态"],
      title: '修改资源库',
      myform: {},
      dialogFormVisible: this.$store.state.user.dialogFormVisible,
      changeData: [],
      dataIndex: 0,  //需要改变table的索引
    }
  },
  methods: {
    ...mapActions(["setDialogFormVisible"]),
    changeClick (scope) {
      this.getLibAsync(scope.row.id)
      this.setDialogFormVisible(true)

    },
    //删除图片库
    removeClick (scope) {
      this.$emit('removeClick', scope)
    },
    //关闭或者开始图片库
    closeClick (scope) {
      this.$emit('closeClick', scope)
    },
    //接受dialog组件提交之后传递过来的值
    dialogSubmit (data) {
      this.$emit('formSubmit', data)
    },
    //查询图片库
    async getLibAsync (val) {
      let { status, data, message, errors } = await getLib(val);
      if (status) {
        this.myform = {
          one: data.name,
          two: data.sort,
          three: data.status,
          ...data
        }
        // console.log(this.myform)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
  },
  created () {

  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}
.btn:hover {
  text-decoration: underline;
}
</style>
